<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="editRecurso && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmitRecurso" v-if="!editRecurso || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!editRecurso || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Programa" prop="programa_id" :rules="[$requiredChange]" key="programa_id">
              <el-select v-model="dados.programa_id" placeholder="pesquisar..." filterable remote :remote-method="getProgramaByFilter" :loading="loadingPrograma">
                <el-option v-for="item in programas" :key="item.id" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Ano" prop="ano" :rules="[$requiredBlur]" key="ano">
              <el-input v-model="dados.ano" maxlength="4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Valor total" prop="valor_total" :rules="[$requiredBlur]" key="valor_total">
              <el-input v-model="dados.valor_total" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Capital" prop="valor_capital" key="valor_capital">
              <el-input v-model="dados.valor_capital" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Custeio" prop="valor_custeio" key="valor_custeio">
              <el-input v-model="dados.valor_custeio" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data de recebimento" prop="data_recebimento" key="data_recebimento">
              <el-date-picker v-model="dados.data_recebimento" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item label="Conta bancária" prop="conta_bancaria" key="conta_bancaria">
              <el-input v-model="dados.conta_bancaria" maxlength="191" v-on:blur="formatData('conta_bancaria')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Observação" prop="observacao" key="observacao">
              <el-input type="textarea" :rows="4" v-model="dados.observacao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-recurso" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    editRecurso: false,
    loadingPrograma: false,
    programas: [],
    filtroInstituicao: { id: '', nome: '' },
    dados: {
      id: '',
      instituicao_id: '',
      programa_id: '',
      ano: '',
      valor_total: '',
      valor_capital: '',
      valor_custeio: '',
      data_recebimento: '',
      conta_bancaria: '',
      observacao: ''
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    getRecursoById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/recurso/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => {
          const data = JSON.parse(JSON.stringify(response.data))

          // Pré-popular options do select remoto (senão ele mostra o ID)
          if (data && data.programa) {
            this.programas = [{ id: data.programa.id, nome: data.programa.nome }]
            delete data.programa
          }

          this.dados = data
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    getProgramaByFilter (query) {
      if (!query || query.length < 2) {
        this.programas = []
        return false
      }
      this.loadingPrograma = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/programa/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.programas = JSON.parse(JSON.stringify(response.data))
        this.loadingPrograma = false
      }).catch((error) => { this.loadingPrograma = false; this.$store.commit('throwException', error) })
    },
    onSubmitRecurso () {
      document.getElementById("btn-recurso").focus()

      this.$refs.dados.validate((valid) => {
        if (valid) {
          const inst = this.$store.state.config.instituicao
          if (!inst || !inst.id) {
            return window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de salvar.', type: 'warning' })
          }
          window.eventBus.$emit('loading', true)
          this.dados.instituicao_id = inst.id

          if (this.editRecurso) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/recurso/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitRecurso')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          } else {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/recurso/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitRecurso')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          }
        } else {
          window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        }
      })
    },
    formatData (field) {
      if (!this.dados[field]) return false
      this.dados[field] = this.dados[field].toUpperCase()
      this.dados[field] = this.$removerAcentos(this.dados[field])
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getRecursoById(value)
          this.editRecurso = true
        }
      }
    }
  }
}
</script>

